import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import Tooltip      from 'src/components/Tooltip'
import matchingCopy from 'src/components/matchingCopy'

const Matching = ({ i18n, currency, matching }) =>
  <div className="widget-content bg-white p-3 p-sm-4" style={{ isolation: 'auto' }}>
    <div className="text-center">
      <span className="me-2">
        Want to double your impact? {matching.subject} is matching donations!
      </span>
      <Tooltip
        title={matchingCopy(matching, amount => i18n.formatCurrency(amount, currency))}
      >
        <FontAwesomeIcon icon={faInfoCircle} className="text-primary" />
      </Tooltip>
    </div>
  </div>

export default Matching
